import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { Router } from '@angular/router';
import { SickLeaveListService } from '../services/sick-leave-list.service';

@Injectable()
export class AuthGuard implements CanActivate {

  constructor(private sickLeaveListService: SickLeaveListService, private route: Router) { }


  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    if (!this.sickLeaveListService.checkForToken()) {
      this.sickLeaveListService.redirectToSAB();
      return false;
    }
    else {
      this.route.navigate['sickLeaveList'];
      return true;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/guard/auth.guard.ts